
/**
 * Created by lenovo on 2017/2/20.
 */
import React, {
    Component,
    PropTypes
} from 'react';

import {ellaUrl,gateWayUrl} from 'CONFIG/path.config'
import {hashHistory} from 'react-router'
import ellaService from 'SERVICES/purifier/ella/ellaService'
import {hex_md5} from 'UTIL/md5'
import {language}from 'UTIL/common'
import Tip from 'COMPONENT/tip'
export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginState: 'login_error',
            url: ellaUrl,
        }
    }

    componentDidMount() {
        sessionStorage.getItem('auth') == 'ok' ? this.setState({
                loginState: 'login_success'
            }) : "";
        if(sessionStorage.getItem('auth') == 'Unauthorized'){
            $("#error_msg").text('账户登陆已过期,请重新登陆！');
            $("#error_tip").removeClass("hidden");
            $("#error_tip").focus();
            setTimeout(function () {
                $("#error_tip").addClass("hidden");
            }, 3000);
        }
    }

    login() {
        const _this = this;
        const email = $.trim(this.refs.email.value);
        const pass = $.trim(this.refs.pass.value);
        if(email == ""){
            $("#error_msg").text('账号未填写！');
            $("#error_tip").removeClass("hidden");
            setTimeout(function () {
                $("#error_tip").addClass("hidden");
            }, 3000);
            _this.setState({
                loginState: 'login_error'
            })
        }else if(pass == ''){
            $("#error_msg").text('密码未填写！');
            $("#error_tip").removeClass("hidden");
            setTimeout(function () {
                $("#error_tip").addClass("hidden");
            }, 3000);
            _this.setState({
                loginState: 'login_error'
            })
        }else{
            const arr = {
                'login': email,
                'password': hex_md5(pass).toUpperCase(),
            };
            console.log(arr);
            var data = JSON.stringify(arr);
            ellaService.login({data}).then(body=>{
                console.log(body)
                if(body.code == 8001){
                    sessionStorage.setItem('loginName',email);
                    sessionStorage.setItem('auth','ok');
                    sessionStorage.setItem('userId',body.data);
                    hashHistory.push("/")
                }else{
                    $("#error_msg").text(body.msg||body.message);
                    $("#error_tip").removeClass("hidden");
                }
            })
        }

    }
    onChange(id){
        $("#error_tip").addClass("hidden");
    }
    render() {
        return (
            <div>
                <div style={{"minHeight": "600px"}}>
                    <div className="login-box">
                        <div className="login-logo">
                            <a ></a>
                        </div>
                        <div className="login-box-body">
                            <img src="../css/images/logo_2.png" style={{height:'80px',marginLeft:'-15px'}}/>
                            <Tip ids=""/>
                            <form >
                                <div className="form-group has-feedback">
                                    <input ref="email" className="form-control" placeholder={language()['loginName']}
                                    onChange={this.onChange.bind(this,'email')}/>
                                    <span className="glyphicon glyphicon-user form-control-feedback"></span>
                                </div>
                                <div className="form-group has-feedback">
                                    <input type="password" ref="pass" className="form-control"
                                           onChange={this.onChange.bind(this,'pass')} placeholder={language()['password']}/>
                                    <span className="glyphicon glyphicon-lock form-control-feedback"></span>
                                </div>
                                <div className="row">
                                    <div className="col-xs-4">

                                    </div>
                                    <div className="col-xs-4">
                                        <a id="loginClick" className="btn btn-primary btn-block btn-flat"
                                           onClick={this.login.bind(this)}>{language()['login']}</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./modules/login.js